<template>

<!--  <div class="title is-5 mb-2">{{money(computed_items._source.ListPrice)}}<template v-if="computed_items._source.SystemDealType == 'RENT'">/mo</template>-->
<!--  </div>-->
  <div class="">

    <div class=" p-0 m-0 info-detail">
      <div class="image_column mb-1">
        <img  class="tooltip-image"
             draggable="false"
             :src="computed_items._source.ListPictureURL ? computed_items._source.ListPictureURL : require('@/assets/no_image.png')">
      </div>
      <div class=" info_column">

        <div class="title is-6 mb-1">{{money(computed_items._source.ListPrice)}}<template v-if="computed_items._source.SystemDealType == 'RENT'">/mo</template>
        </div>
        <div class="mb-1  address">
          <p>
            {{computed_items._source.FullStreetAddress.toLowerCase()}},
          </p>
          <p>
            {{computed_items._source.City.toLowerCase()}}
            <template v-if="computed_items._source.StateOrProvince">{{computed_items._source.StateOrProvince.toUpperCase()}}</template>
            <template v-if="computed_items._source.StateOrProvince">{{computed_items._source.PostalCode.toLowerCase()}}</template>
          </p>
        </div>
        <div class="is-6 mb-1 ">
          <span class="mr-1" v-if="computed_items._source.BedroomsTotal">{{computed_items._source.BedroomsTotal}} bds</span>
          <span class="mr-1" v-if="TotalBaths(computed_items)">{{TotalBaths(computed_items)}} ba</span>
          <span class="mr-1" v-if="computed_items._source.AreaTotal">{{computed_items._source.AreaTotal}} sqft</span>

        </div>

      </div>
    </div>
  </div>
</template>
<script>


export default {
  name: 'front_base_realty_list_popup',
  components: {

  },
  props: {
    items:null,
    selected: null
  },
  data() {
    return {
      default_items: {},
      isLoading: false,
      error: false,
      hovered: false
    }
  },
  computed: {
    computed_items: function () {
      return this.items;
    }
  },
  methods: {
    TotalBaths(item) {
      const bathCount =  (item._source.MainLevelTotalBaths? parseInt(item._source.MainLevelTotalBaths) : 0)
          + (item._source.UpperLevel1FullBaths ? parseInt(item._source.UpperLevel1FullBaths) : 0)
          + (item._source.LowerLevel1FullBaths ? parseInt(item._source.LowerLevel1FullBaths) : 0);
      return bathCount;
    },
    select(item) {
      this.$emit('select', item);
    },
    highlight(item) {
      this.$emit('highlight', item);
    },
    contact(item) {
      this.$emit('contact', item);
    },
    money(val) {
      return parseInt(val).toLocaleString('en-US', { style: 'currency', currency: 'USD',  minimumFractionDigits: 0,
        maximumFractionDigits: 0 });
    }
  },
  mounted() {

  },
  watch: {
    hovered: function() {
      this.highlight(this.computed_items);
    }
  },
}
</script>

<style scoped>
.image{


}

.article {
  /*box-shadow: 0 0.0625rem 0.1875rem #cacaca;*/
  /*background-color: #fff;*/
  /*margin-bottom: .9375rem;*/
  /*position: relative;*/
  /*opacity: 1;*/
  /*transition: opacity ease-out .3s;*/

  /*aspect-ratio: 10 / 5;*/
  /*width: 100%;*/
}
.article:hover {
  /*border-right: 2px solid blue;*/
}

.article.active {
  /*border-right: 3px solid blue;*/
}

.mobile {
  display: none;
}
.image_column, .info_column {
  padding: 0;
}
.image{
  border-radius: 0;
}
.address {
  overflow-wrap: break-word;
}
.tooltip-image {
  width: 280px !important;
  max-width: 150px;
}
</style>
<style >

</style>
